module.exports = "https://static.zego.com/_next/static/images/FlintInsurance-78879bd1fd116be4013968b1dd50c49c.png";